import ImageSection from "./image-section";

export default ImageSection;
